module.exports = __webpack_public_path__ + "static/img/gift-box-opend-img.36bc2a3.png";